/**
 * <progress-bar-display> web component
 *
 * A lightweight portal that clones the hidden <progress-bar> source element
 * and appends it as a visible child. Each clone is an independent
 * <progress-bar> instance with its own MinimogEvents listener, so multiple
 * displays on the same page (e.g. product section + cart drawer) each update
 * independently in response to cart changes.
 *
 * The source <progress-bar> element is placed in layout/theme.liquid via the
 * Progress Bar section (hidden wrapper). It must be present in the DOM when
 * this component connects.
 *
 * Usage:
 *   <progress-bar-display></progress-bar-display>
 */
class ProgressBarDisplay extends HTMLElement {
  connectedCallback() {
    const sourceProgressBar = document.querySelector('progress-bar');

    if (!sourceProgressBar) {
      console.warn('[progress-bar-display] No <progress-bar> source element found in the DOM.');
      return;
    }

    const clone = sourceProgressBar.cloneNode(true);
    
    this.appendChild(clone);
  }
}

customElements.define('progress-bar-display', ProgressBarDisplay);
